import { apiClient } from './client'

export type AdminRoleDto = {
  roleId: string
  label: string
  description?: string | null
  permissions: string[]
}

export type AdminUserDto = {
  userId: string
  email: string
  displayName?: string | null
  status?: 'active' | 'invited' | 'disabled' | string | null
  role?: {
    roleId: string
    label: string
  } | null
}

export type PermissionDefinitionDto = {
  id: string
  description: string
}

export type AdminUsersResponseDto = {
  organizationId: string
  users: AdminUserDto[]
}

export type AdminRolesResponseDto = {
  organizationId: string
  roles: AdminRoleDto[]
}

export type AvailablePermissionsResponseDto = {
  availablePermissions: PermissionDefinitionDto[]
}

export type CreateInvitationRequest = {
  email: string
  firstname: string
  lastname?: string
  roleName: string
  /**
   * SOLY-TEAM-001 deferred invitation: target an existing team member without
   * access — acceptance grants access on this user instead of creating one.
   */
  userId?: string
}

export async function getAdminRoles(): Promise<AdminRolesResponseDto> {
  return apiClient.get<AdminRolesResponseDto>('/admin/roles')
}

export async function getAdminUsers(): Promise<AdminUsersResponseDto> {
  return apiClient.get<AdminUsersResponseDto>('/admin/users')
}

export async function getPermissionsCatalog(): Promise<AvailablePermissionsResponseDto> {
  return apiClient.get<AvailablePermissionsResponseDto>('/permissions')
}

export async function createInvitation(request: CreateInvitationRequest): Promise<void> {
  await apiClient.post<void>('/invitations', request)
}

export type ChangeUserRoleRequest = {
  roleName: string
}

export async function changeUserRole(userId: string, request: ChangeUserRoleRequest): Promise<void> {
  await apiClient.put<void>(`/admin/users/${userId}/role`, request)
}

export async function removeUser(userId: string): Promise<void> {
  await apiClient.delete<void>(`/admin/users/${userId}`)
}

export async function revokeInvitation(invitationId: string): Promise<void> {
  await apiClient.delete<void>(`/admin/users/invitations/${invitationId}`)
}

export type CreateRoleRequest = {
  name: string
  permissions: string[]
}

export async function createRole(request: CreateRoleRequest): Promise<void> {
  await apiClient.post<void>('/admin/roles', request)
}

export async function deleteRole(roleName: string): Promise<void> {
  await apiClient.delete<void>(`/admin/roles/${roleName}`)
}

export type UpdateRolePermissionsRequest = {
  permissions: string[]
}

export async function updateRolePermissions(
  roleName: string,
  request: UpdateRolePermissionsRequest
): Promise<void> {
  await apiClient.put<void>(`/admin/roles/${roleName}/permissions`, request)
}
